export default __webpack_public_path__ + "static/media/current-offers.31c2e324.png";